import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagic, faSpinner } from "@fortawesome/free-solid-svg-icons";
import "./AIAssistButton.css";

/**
 * AI Assist Button Component
 * Provides AI-powered content generation for forms
 */
const AIAssistButton = ({
  onGenerate,
  loading = false,
  tooltip = "Generate with AI (Ctrl+Space)",
  size = "normal", // "small" | "normal" | "large"
}) => {
  const [showTooltip, setShowTooltip] = useState(false);

  return (
    <div className="ai-assist-container">
      <button
        type="button"
        className={`ai-assist-btn ${size} ${loading ? "loading" : ""}`}
        onClick={onGenerate}
        disabled={loading}
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
        title={tooltip}
      >
        <FontAwesomeIcon icon={loading ? faSpinner : faMagic} spin={loading} />
        {size !== "small" && (
          <span>{loading ? "Generating..." : "AI Assist"}</span>
        )}
      </button>
      {showTooltip && !loading && <div className="ai-tooltip">{tooltip}</div>}
    </div>
  );
};

export default AIAssistButton;
